import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, Input, OnDestroy, OnInit, ViewChild } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { BaseSiteService, OccEndpointsService, RoutingService } from "@spartacus/core";
import { UserAccountFacade } from "@spartacus/user/account/root";
import { Subscription } from "rxjs";
import { take } from "rxjs/operators";
import { LoactionStripService } from "src/app/shared/modules/location-strip/loaction-strip.service";
import { BaseService } from "src/app/shared/services/base.service";
import { ExcelDownloadService } from "src/app/shared/services/excel-download.service";
import { SharedService } from "src/app/shared/services/shared.service";
import * as config from '../../../app/shared/config/app.config';
import { CustomInfluenzaService } from "../custom-influenza.service";
import { ProductDetailsInfluenzaComponent } from "../product-details-influenza/product-details-influenza.component";

@Component({
  selector: 'app-wait-list',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './wait-list.component.html',
  styleUrls: ['./wait-list.component.scss']
})
export class WaitListComponent implements OnInit, OnDestroy {
  delHrs: any;
  b2bUnitID: any;
  json = JSON.stringify({ "excel": "QQQ", "wwww": "pppp" });
  userData: any = [];
  displayActiveSeasons: boolean = false;
  @Input() public standardCartCode;
  @Input() public delTime;
  @ViewChild('box') input: ElementRef<HTMLInputElement>;
  @ViewChild('faxnumber') faxNumber: ElementRef<HTMLInputElement>;
  baseUrl: any;
  imgAvailable: boolean = false;
  userId: any;
  POnameEdited: boolean = false;
  ContactnameEdited: boolean = false;
  newEmailError: boolean = false;
  masterDataCopy: any;
  faxNumberError: boolean = false;
  dataResCopy: any;
  inValid: boolean = false;
  booleanStatus: boolean = false;
  newemail: boolean = false;
  addnewEmail: string = '';
  numbertext: number;
  contentModule = 'waitlist';
  objPresentationStr = {};
  dataRes: any;
  monograph: any;
  contactmethod: boolean = true;
  monographLink: any;
  dupBaseUrl = 'https://jsapps.czz3177o4e-sanofiave1-d2-public.model-t.cc.commerce.ondemand.com';
  fallbackImage = '../../assets/i18n-assets/sanofi_missing_product.jpg';
  fallbackImageVax = '../../assets/i18n-assets/sanofi_missing_product_vax.jpg';
  baseSiteId: string;

  //US-2229
  isGovtCustomer = false; // by default this is false, to be update in ngOnInit based on b2bunitid
  isGovtLocationSelected = false; // by default this is false, to be update in ngOnInit based on selected locations
  locationListSub: Subscription;
  userSub: Subscription;
  selectedLocations: any;
  seasonPriceContractMapping = [];

  constructor(private readonly modalService: NgbModal,
    private readonly user: UserAccountFacade,
    private readonly baseService: BaseService,
    private readonly influenzaService: CustomInfluenzaService,
    private readonly occEndPoint: OccEndpointsService,
    private readonly router: RoutingService,
    private excelDwnldSrvc: ExcelDownloadService,
    private fb: FormBuilder,
    private baseSiteService: BaseSiteService,
    private readonly sharedService: SharedService,
    private locStripService: LoactionStripService,
    protected cd: ChangeDetectorRef) {
    this.baseUrl = this.occEndPoint.getBaseUrl({
      baseUrl: true,
      prefix: false,
      baseSite: false,
    });
  }
  contactForm: FormGroup = this.fb.group({
    poName: ['', Validators.required],
    name: [''],
    email: [''],
    fax: [''],
    placed: ['']
  });
  editPo: boolean = false;
  editContact: boolean = false;
  editDeliveryHrs = false;
  ngOnInit(): void {
    this.baseSiteService.getActive().pipe(take(1)).subscribe(res => this.baseSiteId = res);

    this.isGovtCustomer = this.sharedService.getLocalStorage('isGovtCustomer');
    // this.isGovtLocationSelected=this.isGovLocationSelected();
    this.cd.detectChanges();
    //Updating isGovtLocationSelected based on change in location from the page.
    this.locationListSub = this.locStripService.emitSelectedLocs.subscribe(locsData => {
      if (locsData && locsData?.length > 0) {   //if there is any selected location
        this.selectedLocations = locsData;
        this.isGovtLocationSelected = this.isGovLocationSelected(true);
        this.cd.detectChanges();
      }
      else {   //no location selected. check for isDefaultLocationGovt flag
        this.isGovtLocationSelected = this.sharedService.getSessionStorage('isDefaultLocationGovt');
      }
    })

    this.contactForm["in-valid"] = false;
    if (this.contactForm.value.name != '' && this.contactForm.value.email != '') {
      this.booleanStatus = true;
    }
    else {
      this.booleanStatus = false;
    }
    this.userSub = this.user.get().subscribe((res: any) => {
      if (res) {
        this.userData = res;
        this.baseService.get(config.GET_ACCOUNT_ID).subscribe((res) => {
          this.b2bUnitID = res?.defaultB2BUnit?.uid;
          var dt = this.influenzaService.getWaitListDetails(this.userData.uid, this.b2bUnitID);
        });
        this.userSub?.unsubscribe();
      }
    });
    var arrForEmailRightSide = [];
    this.influenzaService.waitList.subscribe((res) => {
      this.dataRes = res;
      //this.dataRes.contactFax = "";
      if (!this.dataRes.hasOwnProperty("deliveryHoursInfo")) {
        this.dataRes.deliveryHoursInfo = JSON.parse(localStorage.getItem("deliveryHoursWaitList"));
      }
      this.cd.detectChanges();
      this.masterDataCopy = JSON.parse(JSON.stringify(this.dataRes));
      this.delHrs = this.dataRes?.deliveryHoursInfo;



      arrForEmailRightSide = this.dataRes?.customerEmails;
      arrForEmailRightSide.push(this.dataRes?.contactEmail);
      this.dataRes["arrForEmailRightSide"] = arrForEmailRightSide;
      this.dataRes.seasonOrders.forEach((ele) => {
        let thumbNailImg = '';
        //Calling pricing api only in case of govt customer & if there is waitlist product in that season
        if (this.isGovtCustomer && ele?.waitlistOrders?.length > 0) {
          //call pricing api for the season
          this.influenzaService.getActiveSeasonPriceV2(this.userData.uid, ele?.code)
            .pipe(take(1)).subscribe(res => {
              if (res) {
                let obj = {
                  season: ele?.code,
                  priceAndContract: res?.priceAndAvailability
                }
                this.seasonPriceContractMapping.push(obj);
                // this.updateContractFlag=true;
                this.updateRespWithContractInfoV2();
              }
            });
        }
        ele.waitlistOrders.forEach(ele2 => {
          if (!ele2.product.hasOwnProperty('images')) {
            if (this.baseSiteId == 'vsh') {
              ele2.product.thumbNailImg = this.fallbackImage;
            } else {
              ele2.product.thumbNailImg = this.fallbackImageVax;
            }
            this.imgAvailable = false;
          }
          else {
            this.imgAvailable = true;
            ele2.product.thumbNailImg = this.baseUrl + ele2.product?.images[5]?.url;
          }

          ele2["TotalitemQty"] = ele2.quantity * ele2.product.quantityPerUnit;
          if (ele2.quantity > 0) {
            this.objPresentationStr[ele2.product.code] = ele2.quantity;
          }
        });
      });
      this.cd.detectChanges();
      if (this.dataRes?.emailSelected) {
        this.contactmethod = false;
      }
      this.cd.detectChanges();
    });
    this.cd.detectChanges();
  }
  close(): void {
    this.modalService.dismissAll();
  }

  editPO() {
    this.editPo = true;
    this.cd.detectChanges();
  }
  editContactmethod() {
    this.editContact = true;
    this.cd.detectChanges();
  }
  changePOname() {
    this.POnameEdited = true;
    this.cd.detectChanges();
  }
  changeContactname() {
    this.ContactnameEdited = true;
    this.cd.detectChanges();
  }
  downloadfile() {
    let data = [];
    let j = 0;
    this.dataRes?.seasonOrders.forEach(el => {
      for (var i = 0; i < el.waitlistOrders.length; i++) {
        if (this.dataRes.seasonOrders[j].waitlistOrders[i].quantity > 0) {
          var obj = {
            'CUSTOMER_ID': this.dataRes?.shipto,
            'MATERIAL_ID': this.dataRes?.seasonOrders[j]?.waitlistOrders[i]?.product?.code,
            'QUANTITY': this.dataRes?.seasonOrders[j]?.waitlistOrders[i]?.quantity,
            'SHIP_TO': this.dataRes?.shipto,
            'PO_NUMBER': this.dataRes?.poNumber,
            'CONTACT_NAME': this.dataRes?.contactName,
            'EMAIL/FAX_SELECTION': this.dataRes.emailSelected ? 'Email' : 'Fax',
            'EMAIL_ADDRESS / FAX_NUMBER': this.dataRes.emailSelected ? this.dataRes.contactEmail : this.dataRes.contactFax,
            'PLACED_BY': this.dataRes?.placedBy,
            'DELIVERY_HOURS': this.dataRes?.deliveryHours
          }
          data.push(obj);
        }
      }
      j++;
    })
    this.excelDwnldSrvc.exportAsExcelFile(data, 'WaitListOrderDetails', true);
  }
  triggerFunc(e: any) {
    this.delHrs = e;
    this.dataRes.deliveryHoursInfo = this.delHrs;
    this.cd.detectChanges();
  }
  validateEmail(emailID) {
    const emailRegx = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,15}$/;
    if (emailRegx.test(emailID)) {
      return true;
    }
    return false;
  }

  saveAllData() {
    if (!this.dataRes.emailSelected) {
      if (this.dataRes.contactFax == undefined) {
        this.faxNumberError = true;
        this.editContact = true;
        return false;
      }
      else {
        this.faxNumberError = false;
      }
    }
    if (this.editContact) {
      if ("addnewemail" in this.dataRes) {
        if (this.validateEmail(this.dataRes?.addnewemail)) {
          this.dataRes.contactEmail = this.dataRes?.addnewemail;
        }
      }
    }
    this.dataResCopy = this.dataRes;
    delete this.dataResCopy.arrForEmailRightSide;

    this.dataResCopy?.deliveryHoursInfo?.forEach(el => {
      el['fromTime'] = el?.fromTime.trim();
    });
    if (this.dataRes.disableFax) {
      this.dataResCopy["emailSelected"] = this.contactmethod ? false : true;
    }
    else {
      this.dataResCopy["emailSelected"] = true;
    }
    if (this.newemail) {
      if (this.input.nativeElement.value != '' && this.validateEmail(this.input.nativeElement.value)) {
        this.newEmailError = false;
        this.baseService.get(config.GET_ACCOUNT_ID).subscribe((res) => {
          this.b2bUnitID = res?.defaultB2BUnit?.uid;
          var payload = this.dataResCopy;
          delete payload.addnewemail;
          this.influenzaService.saveWaitList(this.userData?.uid, this.b2bUnitID, payload);
        });
        this.influenzaService.addedWaitlist.subscribe(res => {
          if (res.status == 'success') {
            location.reload();
          }
        })
      }
      else {
        this.newEmailError = true;
      }
    }
    else {
      this.baseService.get(config.GET_ACCOUNT_ID).subscribe((res) => {
        this.b2bUnitID = res?.defaultB2BUnit?.uid;
        this.influenzaService.saveWaitList(this.userData?.uid, this.b2bUnitID, this.dataResCopy);
      });
      this.influenzaService.addedWaitlist.subscribe((res) => {
        if (res.status == 'success') {
          {
            this.influenzaService.getWaitListDetails(this.userData.uid, this.b2bUnitID);
            this.influenzaService.waitList.subscribe((res) => {
              this.dataRes = JSON.parse(JSON.stringify(res));
              this.delHrs = res?.deliveryHoursInfo;
              this.dataRes.seasonOrders.forEach((ele) => {
                let thumbNailImg = '';
                ele.waitlistOrders.forEach(ele2 => {
                  if (!ele2.product.hasOwnProperty('images')) {
                    if (this.baseSiteId == 'vsh') {
                      ele2.product.thumbNailImg = this.fallbackImage;
                    } else {
                      ele2.product.thumbNailImg = this.fallbackImageVax;
                    }
                    this.imgAvailable = false;
                  }
                  else {
                    this.imgAvailable = true;
                    ele2.product.thumbNailImg = this.baseUrl + ele2.product?.images[5]?.url;
                  }
                })
              });
              this.dataRes.seasonOrders.forEach((ele) => {
                ele.waitlistOrders.forEach(element => {
                  element["TotalitemQty"] = element.quantity * element.product.quantityPerUnit;
                  if (element.quantity > 0) {
                    this.objPresentationStr[element.product.code] = element.quantity;
                  }
                });
              });
            })
            location.reload();
          }
        }
      });
    }
    this.cd.detectChanges();
  }

  addnewemail(vl) {
    this.dataRes["addnewemail"] = vl;
  }

  validateFaxNumber(fxNmbr) {
    if (fxNmbr == '' || fxNmbr.length != 12) {
      this.faxNumberError = true;
    }
    else {
      this.faxNumberError = false;
    }
    this.POnameEdited = true;
  }
  gotoDashboard() {
    this.router.goByUrl('influenza/dashboard')
  }
  printFunc() {
    window.print();
  }
  getEmailDrpDwnVal(eventValue) {
    if (eventValue.$ngOptionLabel == 'Add new email') {
      this.newemail = true;
    }
    else {
      this.newemail = false;
    }
    this.ContactnameEdited = true;
  }

  changeColor() {
    const el: any = document.getElementsByClassName('ng-option-label');
    if (el.length) {
      el[el.length - 1].style.color = '#AA1396';
    }
  }

  contactmethodValchk(e) {
    this.POnameEdited = true;
    this.newemail = false;

    if (e.target.value == 'fax') {
      if (this.dataRes.contactFax == '' || this.dataRes.contactFax == undefined) {
        this.faxNumberError = true;
      }
      this.contactmethod = true;
      this.dataRes.contactEmail = this.dataRes.arrForEmailRightSide[0];
    }
    else {
      this.dataRes.emailSelected = true;
      this.dataRes.contactFax = this.masterDataCopy.contactFax;
      this.faxNumberError = false;
      this.contactmethod = false;
    }

  }

  performQuantityComputation2(code, quantity, action) {
    this.POnameEdited = true
    var text = $('#prodQuantity' + code).val();
    if (text == '') {
      this.objPresentationStr[code] = 0;
    }
    else {
      this.objPresentationStr[code] = text;
    }
    var KeysString = Object.keys(this.objPresentationStr).toString();
    var arrOkeys = KeysString.split(",");
    this.dataRes.seasonOrders.forEach((ele) => {
      ele.waitlistOrders.forEach(element => {
        arrOkeys.forEach(e => {
          if (element.product.code == e) {
            element["quantity"] = this.objPresentationStr[element.product.code];
            this.inValid = true;
            element["TotalitemQty"] = this.objPresentationStr[element.product.code] * element.product.quantityPerUnit;
          }
        })
      });
    });
    this.cd.detectChanges();
  }
  EditValFunc(e) {
    this.editDeliveryHrs = e;
  }
  performQuantityComputation(code, quantity, action, status) {
    this.POnameEdited = true;
    this.inValid = true;
    var text = $('#prodQuantity' + code).val();
    if (status != 'EXPORTED' || status == 'OPEN' && quantity == 0) {
      if (action == 'add') {

        this.objPresentationStr[code] = Number(text) + 1;
        var KeysString = Object.keys(this.objPresentationStr).toString();
        var arrOkeys = KeysString.split(",");
        this.dataRes.seasonOrders.forEach((ele) => {
          ele.waitlistOrders.forEach(element => {
            arrOkeys.forEach(e => {
              if (element.product.code == e) {
                element["quantity"] = this.objPresentationStr[element.product.code];
                element["TotalitemQty"] = this.objPresentationStr[element.product.code] * element.product.quantityPerUnit;
              }
            })
          });
        });
      }
      if (action == 'less') {
        if (quantity > 0) {
          this.objPresentationStr[code] = Number(text) - 1;
          var KeysString = Object.keys(this.objPresentationStr).toString();
          var arrOkeys = KeysString.split(",");
          this.dataRes.seasonOrders.forEach((ele) => {
            ele.waitlistOrders.forEach(element => {
              arrOkeys.forEach(e => {
                if (element.product.code == e) {
                  element["quantity"] = this.objPresentationStr[element.product.code];
                  element["TotalitemQty"] = this.objPresentationStr[element.product.code] * element.product.quantityPerUnit;
                }
              })
            });
          });
        }
      }
    }
    this.cd.detectChanges();
  }
  closeEdit() {
    location.reload();
  }

  editDetails() {
    this.editPo = true;
  }

  productDetails(productDetails) {
    const modalRef = this.modalService.open(ProductDetailsInfluenzaComponent, { windowClass: `product-details-inf-modal ${this.baseSiteId}` });
    modalRef.componentInstance.productDetails = productDetails;
    modalRef.componentInstance.standardCartCode = productDetails.code;
  }

  isGovLocationSelected(locEmitted?) {
    let selectedLocs;
    let govLocationCounter = 0;
    if (locEmitted) {
      selectedLocs = this.selectedLocations
    }
    else {
      if ('selectedLocations' in sessionStorage) {
        selectedLocs = JSON.parse(sessionStorage.getItem('selectedLocations'));
      }
    }
    selectedLocs?.map(loc => {
      if (loc?.isGovernmentLocation) {
        govLocationCounter++
      }
    });
    if (govLocationCounter > 0) {
      return true;
    }
    return false;
  }

  updateRespWithContractInfoV2() {
    this.dataRes?.seasonOrders?.map(season => {
      if (season?.waitlistOrders?.length > 0) {
        const matchedSeason = this.seasonPriceContractMapping.find(entry => entry?.season === season?.code);

        if (matchedSeason) {
          season?.waitlistOrders.map(order => {
            const matchedProduct = matchedSeason?.priceAndContract?.find(entry => entry?.code === order?.product?.code);
            if (matchedProduct) {
              order['conditions'] = matchedProduct?.conditions;
            }
          });
        }
      }
    });
    this.cd.detectChanges();
  }

  ngOnDestroy(): void {
    this.locationListSub?.unsubscribe();
    this.userSub?.unsubscribe();
  }

}
